<template>
  <div class="my-performance-page">
    <div class="query-card">
      <div class="filter-row">
        <div class="filter-item">
          <label>📅 年度</label>
          <el-select
            v-model="filters.year"
            placeholder="请选择年度"
            style="width: 100%"
          >
            <el-option label="全部" value="all" />
            <el-option
              v-for="item in yearOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="filter-item">
          <label>🍂 季度</label>
          <el-select
            v-model="filters.quarter"
            placeholder="请选择季度"
            style="width: 100%"
          >
            <el-option label="全部" value="all" />
            <el-option label="Q1" value="Q1" />
            <el-option label="Q2" value="Q2" />
            <el-option label="Q3" value="Q3" />
            <el-option label="Q4" value="Q4" />
          </el-select>
        </div>
        <div class="filter-item">
          <label>📆 考核状态</label>
          <el-select
            v-model="filters.status"
            placeholder="请选择状态"
            style="width: 100%"
          >
            <el-option label="全部" value="all" />
            <el-option label="待审核" value="待审核" />
            <el-option label="审核通过" value="审核通过" />
            <el-option label="审核不通过" value="审核不通过" />
            <el-option label="草稿" value="草稿" />
            <el-option label="已提交" value="已提交" />
          </el-select>
        </div>
        <div class="action-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleQuery"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#f8fafc',
          color: '#1f4e43',
          fontWeight: '600',
        }"
        v-loading="loading"
      >
        <el-table-column
          prop="year"
          label="考核年度"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="period"
          label="考核周期"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="type"
          label="考核类型"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="score"
          label="员工得分"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <strong style="color: #1e6f5c">{{ scope.row.score }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="180" align="center">
          <template slot-scope="scope">
            <span :class="['status-badge', getStatusClass(scope.row.status)]">
              {{ getStatusClass(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="submitDate"
          label="提交时间"
          width="180"
          align="center"
        />
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </div>

    <div class="footer-note">
      <span
        >💡
        说明：我的绩效展示本人相关的考核数据（已隐藏绩效等级和操作按钮）。</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPerformance',
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      yearOptions: [],
      tableData: [],
    };
  },
  computed: {
    // 移除前端的 filteredData，改为直接使用传入的 dataList
  },
  watch: {
    dataList: {
      handler(newVal) {
        this.tableData = newVal || [];
      },
      immediate: true,
    },
  },
  mounted() {
    this.generateYearOptions();
  },
  methods: {
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      this.yearOptions = [];
      for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        this.yearOptions.push({
          value: `${year}`,
          label: `${year}年`,
        });
      }
    },
    handleQuery() {
      // 触发父组件的查询事件，重置页码为1
      this.$emit('query');
    },
    handleReset() {
      // 重置筛选条件
      this.$emit('reset');
    },
    handleSizeChange(val) {
      // 改变每页条数
      this.$emit('size-change', val);
    },
    handleCurrentChange(val) {
      // 改变当前页
      this.$emit('current-change', val);
    },
    getStatusClass(status) {
      const classMap = {
        0: '草稿',
        1: '待部门领导审核',
        2: '待总经理复核',
        3: '审核通过',
        4: '审核不通过',
      };
      return classMap[status] || '';
    },
  },
};
</script>

<style scoped lang="less">
.my-performance-page {
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.query-card {
  background: #f9fbfd;
  border-radius: 20px;
  padding: 20px 24px;
  margin-bottom: 24px;
  border: 1px solid #eef2f8;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 18px;
  row-gap: 18px;
}

.filter-item {
  display: flex;
  flex-direction: column;
  min-width: 140px;
  flex: 1;

  label {
    font-size: 12px;
    font-weight: 500;
    color: #3c5a6b;
    margin-bottom: 6px;
    letter-spacing: 0.3px;
  }
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin-left: auto;
  align-items: center;
}

.table-wrapper {
  overflow-x: auto;
  border-radius: 18px;
  //border: 1px solid #ecf1f7;
  background: white;
}

.pagination-container {
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ecf1f7;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 11px;
  font-weight: 500;
}

.status-pending {
  background: #ffedd5;
  color: #b45309;
}

.status-approved {
  background: #dff9e6;
  color: #1e6f5c;
}

.status-rejected {
  background: #fee2e2;
  color: #b91c1c;
}

.status-draft back {
  ground: #e6f0fa;
  color: #2c5282;
}

.footer-note {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9edf2;
  font-size: 12px;
  color: #6b8a9b;
  text-align: right;
}
</style>
